import { Stack } from '@mui/material';

import {
  ClientReportAttachmentCard,
  ClientReportDeliveryCard,
  ClientReportDescriptionCard,
  ClientReportEventCard,
  ClientReportLinkCard,
  ClientReportMilestoneCard,
  ClientReportPhotoCard
} from 'modules/components/layer20';
import { ActivitySectionLayout } from 'modules/components/layer32';
import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';



export type ClientReportDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportDetailSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.clientReportId ?? '');
  return (
    <ActivitySectionLayout.FC>
      <Stack
        direction='row'
        columnGap='1.5rem'
        flexWrap='wrap'
      >
        <ClientReportDescriptionCard.FC
          id={data.id}
          description={data.description}
        />
      </Stack>
      <ClientReportPhotoCard.FC
        id={data.id}
        photos={data.photos}
      />
      <Stack
        direction='row'
        columnGap='1.5rem'
        flexWrap='wrap'
      >
        <ClientReportAttachmentCard.FC
          clientReportId={data.id}
          attachments={data.attachments}
        />
        <ClientReportLinkCard.FC
          id={data.id}
          links={data.links}
        />
      </Stack>
      <ClientReportEventCard.FC
        id={data.id}
        inspections={data.inspections}
      />
      <ClientReportMilestoneCard.FC
        id={data.id}
        milestones={data.milestones}
      />
      <ClientReportDeliveryCard.FC
        id={data.id}
        deliveries={data.deliveries}
      />
    </ActivitySectionLayout.FC>
  );
};
